<template>
    <div>
        <div class="xunjian_box" ref="xunjianMap"></div>
    </div>
</template>

<script>
    export default {
        name: "xunjian_map.vue",
        data(){
            return{

            }
        },
        mounted(){
            this.onWindowResize()
            window.addEventListener('resize', this.onWindowResize);
            this.$nextTick(()=>{
                this.new_map();
            });

        },
        methods:{
            onWindowResize(){
                let pageHeight = document.documentElement.clientHeight; //页面总高度
                if(document.querySelectorAll(".xunjian_box") && document.querySelectorAll(".xunjian_box")[0]){
                    document.querySelectorAll(".xunjian_box")[0].style.height =  pageHeight - 265+ 'px';  //在这里可以根据你的边距做调整
                }
            },
            new_map() {
                // // 绘制折线
                // this.path = new AMap.Polyline({
                //     path: null,
                //     isOutline: false,     //线条是否带描边，默认false
                //     outlineColor: '#ffeeff',//线条描边颜色，此项仅在isOutline为true时有效，默认：#000000
                //     borderWeight: 1,    //描边的宽度，默认为1
                //     strokeColor: "#3366FF", //线条颜色，使用16进制颜色代码赋值。默认值为#006600
                //     strokeOpacity: 1,   //线条透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                //     strokeWeight: 2,    //线条宽度，单位：像素
                //     // 折线样式还支持 'dashed'
                //     strokeStyle: "dashed",  //线样式，实线:solid，虚线:dashed
                //     // strokeStyle是dashed时有效
                //     strokeDasharray: [10, 5],//勾勒形状轮廓的虚线和间隙的样式，此属性在strokeStyle 为dashed 时有效
                //     lineJoin: 'round',    //折线拐点的绘制样式，默认值为'miter'尖角，其他可选值：'round'圆角、'bevel'斜角
                //     lineCap: 'round',   //折线两端线帽的绘制样式，默认值为'butt'无头，其他可选值：'round'圆头、'square'方头
                //     zIndex: 50,       //折线覆盖物的叠加顺序。默认叠加顺序，先添加的线在底层，后添加的线在上层。通过该属性可调整叠加顺序，使级别较高的折线覆盖物在上层显示默认zIndex：50、
                // })
                // // 将折线添加至地图实例
                // this.amap_map.add(this.path);

                // 巡航轨迹
                // var map = new AMap.Map(this.$refs.amapBox, {
                //     zoom: 4,
                //     mapStyle: 'amap://styles/0b430c027c7b96a310568a413e275738',
                //     // disableSocket: true,
                //     // viewMode: '3D',
                //     // resizeEnable: true,
                //     // buildingAnimation: true, //楼块出现是否带动画,
                //     // expandZoomRange: true,
                //     features: ['bg', 'road', 'building', 'point'],
                // });
                //
                // AMapUI.load(['ui/misc/PathSimplifier', 'lib/$'], function(PathSimplifier, $) {
                //
                //     if (!PathSimplifier.supportCanvas) {
                //         alert('当前环境不支持 Canvas！');
                //         return;
                //     }
                //
                //     var pathSimplifierIns = new PathSimplifier({
                //         zIndex: 100,
                //         //autoSetFitView:false,
                //         map: map, //所属的地图实例
                //
                //         getPath: function(pathData, pathIndex) {
                //
                //             return pathData.path;
                //         },
                //         getHoverTitle: function(pathData, pathIndex, pointIndex) {
                //
                //             if (pointIndex >= 0) {
                //                 //point
                //                 return pathData.name + '，点：' + pointIndex + '/' + pathData.path.length;
                //             }
                //
                //             return pathData.name + '，点数量' + pathData.path.length;
                //         },
                //         renderOptions: {
                //
                //             renderAllPointsIfNumberBelow: 100 //绘制路线节点，如不需要可设置为-1
                //         }
                //     });
                //
                //     window.pathSimplifierIns = pathSimplifierIns;
                //
                //     //设置数据
                //     pathSimplifierIns.setData([
                //     {
                //         name: '人员1',
                //         path: [
                //             [116.405289, 39.904987],
                //             [113.964458, 40.54664],
                //             [111.47836, 41.135964],
                //             [108.949297, 41.670904],
                //             [106.380111, 42.149509],
                //             [103.774185, 42.56996],
                //             [101.135432, 42.930601],
                //             [98.46826, 43.229964],
                //             [95.777529, 43.466798],
                //             [93.068486, 43.64009],
                //             [90.34669, 43.749086],
                //             [87.61792, 43.793308]
                //         ]
                //     }]);
                //
                //     //对第一条线路（即索引 0）创建一个巡航器
                //     var navg1 = pathSimplifierIns.createPathNavigator(0, {
                //         loop: true, //循环播放
                //         speed: 1000000 //巡航速度，单位千米/小时
                //     });
                //
                //     navg1.start();
                // });

                //简单数据附加
                var map = new AMap.Map(this.$refs.xunjianMap, {
                    zoom: 4,
                    // mapStyle: 'amap://styles/0b430c027c7b96a310568a413e275738',
                    mapStyle: 'amap://styles/038a3e00c8b9ffce298be9b7eb94cbd8'
                });
                var defaultRenderOptions = {
                    renderAllPointsIfNumberBelow: -1,
                    pathTolerance: 2,
                    keyPointTolerance: 0,
                    pathLineStyle: {
                        lineWidth: 1,
                        strokeStyle: 'yellow',
                        borderWidth: 1,
                        borderStyle: '#eeeeee',
                        dirArrowStyle: false
                    },
                    pathLineHoverStyle: {
                        lineWidth: 3,
                        strokeStyle: 'rgba(204, 63, 88,1)',
                        borderWidth: 1,
                        borderStyle: '#cccccc',
                        dirArrowStyle: false
                    },
                    pathLineSelectedStyle: {
                        lineWidth: 6,
                        strokeStyle: '#C11534',
                        borderWidth: 1,
                        borderStyle: '#cccccc',
                        dirArrowStyle: true
                    },
                    dirArrowStyle: {
                        stepSpace: 35,
                        strokeStyle: '#ffffff',
                        lineWidth: 2
                    },
                    startPointStyle: {
                        radius: 4,
                        fillStyle: '#109618',
                        lineWidth: 1,
                        strokeStyle: '#eeeeee'
                    },
                    endPointStyle: {
                        radius: 4,
                        fillStyle: '#dc3912',
                        lineWidth: 1,
                        strokeStyle: '#eeeeee'
                    },
                    keyPointStyle: {
                        radius: 3,
                        fillStyle: 'rgba(8, 126, 196, 1)',
                        lineWidth: 1,
                        strokeStyle: '#eeeeee'
                    },
                    keyPointHoverStyle: {
                        radius: 4,
                        fillStyle: 'rgba(0, 0, 0, 0)',
                        lineWidth: 2,
                        strokeStyle: '#ffa500'
                    },
                    keyPointOnSelectedPathLineStyle: {
                        radius: 4,
                        fillStyle: 'rgba(8, 126, 196, 1)',
                        lineWidth: 2,
                        strokeStyle: '#eeeeee'
                    }
                };


                AMapUI.load(['ui/misc/PathSimplifier', 'lib/$'], function(PathSimplifier, $) {

                    if (!PathSimplifier.supportCanvas) {
                        alert('当前环境不支持 Canvas！');
                        return;
                    }

                    var pathSimplifierIns = new PathSimplifier({
                        zIndex: 100,
                        //autoSetFitView:false,
                        map: map, //所属的地图实例

                        getPath: function(pathData, pathIndex) {
                            console.log(pathData,'11111111111111')

                            var points = pathData.points,
                                lnglatList = [];

                            for (var i = 0, len = points.length; i < len; i++) {
                                lnglatList.push(points[i].lnglat);
                            }

                            return lnglatList;
                        },
                        getHoverTitle: function(pathData, pathIndex, pointIndex) {

                            if (pointIndex >= 0) {
                                //point
                                // return pathData.name + '，' + pathData.points[pointIndex].name;
                            }

                            // return pathData.name + '，点数量' + pathData.points.length;
                        },
                        renderOptions: defaultRenderOptions,
                        // renderOptions: {
                        //
                        //     renderAllPointsIfNumberBelow: 100 //绘制路线节点，如不需要可设置为-1
                        // }
                    });

                    window.pathSimplifierIns = pathSimplifierIns;

                    //设置数据
                    pathSimplifierIns.setData([
                        {
                            name: '巡检人员1',
                            points: [{
                                lnglat: [116.405289, 39.904987]
                            }, {
                                lnglat: [113.964458, 40.54664]
                            }, {
                                lnglat: [111.47836, 41.135964]
                            }, {
                                lnglat: [108.949297, 41.670904]
                            }, {
                                lnglat: [106.380111, 42.149509]
                            }, {
                                lnglat: [103.774185, 42.56996]
                            }, {
                                lnglat: [101.135432, 42.930601]
                            }, {
                                lnglat: [98.46826, 43.229964]
                            }, {
                                lnglat: [95.777529, 43.466798]
                            }, {
                                lnglat: [93.068486, 43.64009]
                            }, {
                                lnglat: [90.34669, 43.749086]
                            }, {
                                lnglat: [87.61792, 43.793308]
                            }]
                        },
                    ]);
                    //添加巡航器
                    var navg1 = pathSimplifierIns.createPathNavigator(0, {
                        loop: true, //循环播放
                        speed: 1000000 //巡航速度，单位千米/小时
                    });

                    navg1.start();

                    //选中路线0
                    // pathSimplifierIns.setSelectedPathIndex(0);
                    //
                    // pathSimplifierIns.on('pointClick', function(e, info) {
                    //
                    //     console.log('Click: ' + info.pathData.points[info.pointIndex].name);
                    // });
                });

            },
        }
    }
</script>

<style scoped lang="less">
    .xunjian_box{
        width: 100%;
        /*border: 4px solid #0a3263;*/
        /*padding: 0px 30px 0px 30px;*/

    }
</style>



// WEBPACK FOOTER //
// src/page/main_content/map/baseMap/xunjian_map.vue